import React from 'react';
import { Link } from 'react-router-dom';
import yellowWoman from '../../assets/people.png';
import AIMix from '../../assets/teach2.jpg';

const ITSupport =()=>{

    return(
        <section className='container mx-auto px-4 md:px-0 font-nunito mt-16'>
             <div className="relative">
                <img src={yellowWoman} alt="Slide 3" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <h2 className="text-white text-4xl lg:text-6xl font-bold text-center">24/7 Critical Support</h2>
                </div>
            </div>
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={AIMix} alt="About Us" className="w-full md:w-1/2 md:mt-0 object-cover opacity-70" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>24/7 Critical Support</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                        Driven by innovation, we provide efficient and comprehensive IT support services, enabling businesses to operate 
                        seamlessly around the clock. Our extensive expertise in technology adaptation spans various sectors, making us 
                        the preferred IT partner for leading banks and financial institutions in the region. If you're utilizing any 
                        technology platforms, it’s crucial to have a robust, reliable, and scalable support system in place to ensure 
                        everything runs smoothly. IBS offers proactive support services tailored to your needs, ensuring you get everything 
                        right, just as you envision
                    </p>
                </div>
            </div> <br /><br />
            <div className='md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify items-center'>
                <h1 className='font-bold text-center text-justify lg:text-4xl'>How Can IBS’s IT Support Help You?</h1>
                <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Many businesses have internal support teams, but they often lack the capacity to handle severe threats like ransomware attacks. 
                    This is where IBS comes in. We provide a team of experts you can rely on to restore compromised frameworks and infrastructures. 
                    Our round-the-clock monitoring ensures that any suspicious activities are swiftly detected and addressed. With IBS, you gain access 
                    to a knowledgeable and experienced team 24/7. Not only do we protect and secure your infrastructure, but we also empower your in-house 
                    security team to confidently face any challenges.
                </p>
            </div> <br /><hr /><br />
            <div className="flex flex-col justify-center items-center space-y-4">
                <h1 className="font-bold text-center lg:text-4xl">
                Let’s Have a Fruitful Discussion for an Inventive IT Support Strategy!
                </h1>
                <div>
                <button className="rounded bg-blue-900 py-2 px-4 font-bold text-[#d4af37] transition-transform duration-300 hover:scale-110 hover:bg-[#013751]">
                      <Link to={'/ContactPage'}> Contact Us</Link> 
                    </button>
                </div>
            </div>
        </section>
    )
}
export default ITSupport;